export enum ViewerMode {
  normal = 'normal',
  detailed = 'detailed',
}
